import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config.URL_EXPENSES}`;

const request = async (method, endpoint, data = null) => {
    const url = `${BASE_URL}${endpoint}`;
    try {
        const headers = await headers_get();
        return await axios({ method, url, data, headers });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};

// Funciones para interactuar con las reglas de ingreso
export const income_rules_get = async () => {
    return request('get', '/od/expense-income-rules');
};

export const income_rules_users_get = async () => {
    return request('get', '/od/expense-income-rules/users');
};

export const income_rules_post = async (data) => {
    return request('post', '/od/expense-income-rules', data);
};

export const income_rules_put = async (id, data) => {
    return request('put', `/od/expense-income-rules/${id}`, data);
};

export const income_rule_delete = async (id) => {
    return request('delete', `/od/expense-income-rules/${id}`);
};
